/**
 * «Скидання пароля»: email → «Якщо акаунт із цим email існує, ми надіслали
 * лист» — the same answer for any email.
 */
import { useMutation } from '@tanstack/react-query';
import { type FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { emailSchema } from 'shared';

import { AuthLayout } from '../../components/AuthLayout.js';
import { errorText } from '../../components/errors.js';
import { useLocale } from '../../i18n/locale-context.js';
import { api } from '../../lib/api-client.js';

export function ForgotPasswordPage() {
  const { t, tf } = useLocale();
  const [email, setEmail] = useState('');
  const [checked, setChecked] = useState(false);
  const request = useMutation({
    mutationFn: () => api.post('/auth/password-reset/request', { email: email.trim().toLowerCase() }),
  });
  const emailOk = emailSchema.safeParse(email).success;
  const submit = (e: FormEvent) => {
    e.preventDefault();
    setChecked(true);
    if (emailOk) request.mutate();
  };

  return (
    <AuthLayout>
      <form className="auth-form" noValidate onSubmit={submit}>
        <h1>{t('auth.forgot.title')}</h1>
        {request.isSuccess ? (
          <div className="auth-step">
            <p className="note" aria-live="polite">
              {t('auth.forgot.sent')}
            </p>
          </div>
        ) : (
          <div className="auth-step">
            <p className="sub">{t('auth.forgot.sub')}</p>
            <label className="field">
              <span>{t('auth.email')}</span>
              <input
                type="email"
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                aria-invalid={checked && !emailOk}
              />
              {checked && !emailOk ? <small className="err">{t('auth.err.email')}</small> : null}
            </label>
            {request.error ? (
              <p className="err" role="alert">
                {errorText(request.error, tf)}
              </p>
            ) : null}
            <button className="btn primary wide" type="submit" disabled={request.isPending}>
              {t('auth.forgot.submit')}
            </button>
          </div>
        )}
        <div className="auth-links">
          <Link to="/login">{t('auth.forgot.back')}</Link>
        </div>
      </form>
    </AuthLayout>
  );
}
